<template>
    <section>
        <!-- App bar -->
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiFountainPenTip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Definition of terms
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App bar -->

        <div class="d-flex justify-space-around flex-wrap dot-content-wrapper">
            <div class="col-content">
                <Accident />
                <ActivelyAtWork />
                <AdverseMedicalCondition />
                <AffiliatedHosp />
                <AffiliatedMedicalClinic />
                
                <AffiliatedDoctors />
                <Anesthesiologist />
                <AHMOPI />
                <AttendingPhysician />
                <AuthorizedRepresentative />

                <ContributoryMember />
                <CustodialCareOrMaintenanceCareCopy />
                <MSU />
                <DevelopmentalCongenitalConditionBirthDefectVue />
                <Disability />
                <DueDate />
                
                <DurableMedicalEquipment />
            </div>
            <div class="col-content">
                <EffDate />
                <EligibleExpenses />
                <EmergencyCare />
                <ExpProc />
                <ExpDate />

                <CoordinatingOffice />
                <PIC />
                <HMICare />
                <!-- <HMICard /> -->
                <IdCard />
                <Illness />
                <Injury />

                <InPatientCare />
                <LOA />
                <MaterialInformation />
                <MaximumBenefitLimit />
                <MedicallyNecessary />
                
                <MedicinesAndDrugs />
            </div>
            <div class="col-content">
                <MLC />
                <Member />
                <Membership />
                <NonContributoryMember />

                <OutPatientCare />
                <PhysicianSurgeonSpecialistOrDoctor />
                <PEC />
                <PrivateNurse />

                <ProfessionalFees />
                <RoomAndBoardAccommodation />
                <SelfInflictInjury />
                <SOA />
                <Surgery />

                <Waiver />
            </div>
        </div>
    </section>
</template>

<script>
// import HMI from '@/components/DashboardChildren/MemberGuidelines/DOTComp/HMI.vue'
import Accident from './DOTComp/Accident.vue'
import ActivelyAtWork from './DOTComp/ActivelyAtWork.vue'
import AdverseMedicalCondition from './DOTComp/AdverseMedicalCondition.vue'
import AffiliatedDoctors from '@/components/DashboardChildren/MemberGuidelines/DOTComp/AffiliatedDoctors.vue'
import AffiliatedHosp from '@/components/DashboardChildren/MemberGuidelines/DOTComp/AffiliatedHosp.vue'

import AffiliatedMedicalClinic from './DOTComp/AffiliatedMedicalClinic.vue'
import AHMOPI from '@/components/DashboardChildren/MemberGuidelines/DOTComp/AHMOPI.vue'
import Anesthesiologist from './DOTComp/Anesthesiologist.vue'
import AttendingPhysician from './DOTComp/AttendingPhysician.vue'
import AuthorizedRepresentative from './DOTComp/AuthorizedRepresentative.vue'

import ContributoryMember from './DOTComp/ContributoryMember.vue'
import CoordinatingOffice from '@/components/DashboardChildren/MemberGuidelines/DOTComp/CoordinatingOffice.vue'
import CustodialCareOrMaintenanceCareCopy from './DOTComp/CustodialCareOrMaintenanceCare.vue'
import DevelopmentalCongenitalConditionBirthDefectVue from './DOTComp/DevelopmentalCongenitalConditionBirthDefect.vue.vue'
import DueDate from '@/components/DashboardChildren/MemberGuidelines/DOTComp/DueDate.vue'

import DurableMedicalEquipment from './DOTComp/DurableMedicalEquipment.vue'
import EffDate from '@/components/DashboardChildren/MemberGuidelines/DOTComp/EffDate.vue'
import EligibleExpenses from './DOTComp/EligibleExpenses.vue'
import EmergencyCare from '@/components/DashboardChildren/MemberGuidelines/DOTComp/EmergencyCare.vue'
import ExpDate from './DOTComp/ExpDate.vue'

import ExpProc from '@/components/DashboardChildren/MemberGuidelines/DOTComp/ExpProc.vue'
// import HMICard from '@/components/DashboardChildren/MemberGuidelines/DOTComp/HMICard.vue'
import HMICare from '@/components/DashboardChildren/MemberGuidelines/DOTComp/HMICare.vue'
import IdCard from './DOTComp/IdCard.vue'
import Illness from './DOTComp/Illness.vue'

import Injury from './DOTComp/Injury.vue'
import InPatientCare from '@/components/DashboardChildren/MemberGuidelines/DOTComp/InPatientCare.vue'
import LOA from '@/components/DashboardChildren/MemberGuidelines/DOTComp/LOA.vue'
import MaterialInformation from './DOTComp/MaterialInformation.vue'
import MaximumBenefitLimit from './DOTComp/MaximumBenefitLimit.vue'

import MedicallyNecessary from './DOTComp/MedicallyNecessary.vue'
import MedicinesAndDrugs from './DOTComp/MedicinesAndDrugs.vue'
import Member from './DOTComp/Member.vue'
import Membership from './DOTComp/Membership.vue'
import MLC from '@/components/DashboardChildren/MemberGuidelines/DOTComp/MLC.vue'

import MSU from '@/components/DashboardChildren/MemberGuidelines/DOTComp/MSU.vue'
import NonContributoryMember from './DOTComp/NonContributoryMember.vue'
import OutPatientCare from '@/components/DashboardChildren/MemberGuidelines/DOTComp/OutPatientCare.vue'
import PEC from '@/components/DashboardChildren/MemberGuidelines/DOTComp/PEC.vue'
import PhysicianSurgeonSpecialistOrDoctor from './DOTComp/PhysicianSurgeonSpecialistOrDoctor.vue'

import PIC from '@/components/DashboardChildren/MemberGuidelines/DOTComp/PIC.vue'
import PrivateNurse from './DOTComp/PrivateNurse.vue'
import ProfessionalFees from './DOTComp/ProfessionalFees.vue'
import RoomAndBoardAccommodation from './DOTComp/RoomAndBoardAccommodation.vue'
import SelfInflictInjury from './DOTComp/SelfInflictInjury.vue'

import SOA from './DOTComp/SOA.vue'
import Surgery from './DOTComp/Surgery.vue'
import Waiver from '@/components/DashboardChildren/MemberGuidelines/DOTComp/Waiver.vue'
import Disability from './DOTComp/Disability.vue'
import { mdiFountainPenTip } from '@mdi/js'

export default {
    components: {
        // HMI,
        // 1
        Accident,
        ActivelyAtWork,
        AdverseMedicalCondition,
        AffiliatedDoctors,
        AffiliatedHosp,

        AffiliatedMedicalClinic,
        AHMOPI,
        Anesthesiologist,
        AttendingPhysician,
        AuthorizedRepresentative,

        ContributoryMember,
        CoordinatingOffice,
        CustodialCareOrMaintenanceCareCopy,
        DevelopmentalCongenitalConditionBirthDefectVue,
        Disability,
        DueDate,
        
        DurableMedicalEquipment,

        // 2
        EffDate,
        EligibleExpenses,
        EmergencyCare,
        ExpDate,
        ExpProc,

        // HMICard,
        HMICare,
        IdCard,
        Illness,
        Injury,

        InPatientCare,
        LOA,
        MaterialInformation,
        MaximumBenefitLimit,
        MedicallyNecessary,
        
        MedicinesAndDrugs,

        // 3
        Member,
        Membership,
        MLC,
        MSU,
        NonContributoryMember,

        OutPatientCare,
        PEC,
        PhysicianSurgeonSpecialistOrDoctor,
        PIC,
        PrivateNurse,

        ProfessionalFees,
        RoomAndBoardAccommodation,
        SelfInflictInjury,
        SOA,
        Surgery,

        Waiver
    },
    data: () => ({
        mdiFountainPenTip
    })
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.col-content {
  width: 500px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.dot-content-wrapper {
  width: 95%;
  margin: auto;
}
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  .col-content {
    width: 90%;
  }
  .content {
    width: 100%;
  }
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .col-content {
    width: 33%;
  }
  .content {
    width: 100%;
  }
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .col-content {
    width: 30%;
  }
  .content {
    width: 100%;
  }
}
</style>
